export function getSpeechRecognitionCtor(): (typeof SpeechRecognition) | null {
  if (typeof window === "undefined") return null;
  return window.SpeechRecognition ?? window.webkitSpeechRecognition ?? null;
}

export function isSpeechRecognitionSupported(): boolean {
  return getSpeechRecognitionCtor() !== null;
}

export function isSpeechSynthesisSupported(): boolean {
  return typeof window !== "undefined" && "speechSynthesis" in window;
}

export function stopSpeaking(): void {
  if (!isSpeechSynthesisSupported()) return;
  window.speechSynthesis.cancel();
}

export function speakText(
  text: string,
  lang = navigator.language || "en-US",
): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!isSpeechSynthesisSupported()) {
      reject(new Error("Text-to-speech is not supported in this browser."));
      return;
    }
    const trimmed = text.trim();
    if (!trimmed) {
      resolve();
      return;
    }
    stopSpeaking();
    const utterance = new SpeechSynthesisUtterance(trimmed);
    utterance.lang = lang;
    utterance.rate = 1;
    utterance.pitch = 1;
    utterance.onend = () => resolve();
    utterance.onerror = () => reject(new Error("Speech playback failed."));
    window.speechSynthesis.speak(utterance);
  });
}

export const AI_CHAT_DICTATION_EVENT = "rcm-ai-chat-dictation-active";

export function setChatDictationActive(active: boolean) {
  window.dispatchEvent(
    new CustomEvent(AI_CHAT_DICTATION_EVENT, { detail: { active } }),
  );
}
